:host {
  display: none;
  width: 100%;
  height: 100%;
  background-color: var(--white-layout-300-primary);
  flex-direction: column;
  overflow-y: hidden;
}

:host([data-is-visible]) {
  display: flex;
}

.wrapper {
  flex-direction: column;
}

.header,
.content,
.footer {
  width: 100%;
}

.content {
  flex: 1;
  background: var(--white-layout-301-level-0-elevation);
}
.page__header {
  padding: calc(2 * var(--spacer));
  display: flex;
  align-items: center;
}

.btnBack {
  margin-right: calc(2 * var(--spacer));
}
